<template>
  <v-banner v-if="showBanner" :text="bannerMessage" sticky style="z-index: 9999" bg-color="error">
    <template #prepend>
      <v-icon class="mt-4"> mdi-alert-circle-outline </v-icon>
    </template>
    <template #actions>
      <v-btn-var to="/billing/payment-methods/new">
        {{ t("billing.notification.addMethodButton") }}
      </v-btn-var>
    </template>
  </v-banner>
  <div v-else />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { useBillingStore } from "@/store/billing";
import { useMerchantsStore } from "@/store/merchants";

const { t } = useI18n();
const props = defineProps({
  message: {
    type: String,
    default: "",
  },
});

const billingStore = useBillingStore();
const merchantsStore = useMerchantsStore();
const route = useRoute();
const bannerMessage = computed(() => props.message || t("billing.notification.defaultMessage"));
const showBanner = computed(() => {
  if (route.meta.hideBillingWarningBanner) {
    return false;
  }
  if (
    merchantsStore.currentMerchant &&
    merchantsStore.hasMerchantChurned(merchantsStore.currentMerchant)
  ) {
    return false;
  }
  return billingStore.showNoPaymentMethodsWarning;
});
</script>
